import actions from './actions'
import {nextState, upload, uploadPrepare} from '../helper'

let initState = {
	single: {},
	loading: false,
	total: 0,
	params: {
		query: '',
		limit: 50,
		skip: 0,
	},
	data: []
}

export default function eventReducer(state = initState, action) {

	const {type, payload} = action

	switch (type) {

		case actions.LOAD_SECTION_SUCCESS:
			return {
				...state,
				single: payload
			}

		case actions.CHANGE_SECTION:
			return nextState({
				...state,
				single: {
					...state.single,
					...payload
				}
			})

		case actions.RESET_SECTION:
			return {
				...state,
				single: {}
			}



		case actions.SEARCH_SECTION_PARAMS:
			return {
				...state,
				params: {
					...state.params,
					...payload
				}
			}

		case actions.SEARCH_SECTION_SUCCESS:
			return {
				...state,
				total: payload.total,
				data: payload.data
			}



		case actions.UPLOAD_SECTION:
			return nextState({
				...state,
				single: uploadPrepare(state.single, payload)
			})

		case actions.UPLOAD_SECTION_SUCCESS:
			return nextState({
				...state,
				single: upload(state.single, payload)
			})

		case actions.REMOVE_SECTION:
			return {
				...state,
				data: state.data.filter(rec => rec._id !== payload)
			}

		default:
			return state
	}
}
